import _ from 'lodash'

import UserAuthentication from '@/auth'

async function fetchAccountInfo(targetStore) {
  try {
    const userAuthentication = new UserAuthentication(globalThis.localStorage)

    if (!userAuthentication.isLoggedIn()) return

    targetStore.dispatch('setToken', userAuthentication.getAccessToken())

    if (hasHydratedSession(targetStore)) {
      revalidateSessionInBackground(targetStore)
      return
    }

    await targetStore.dispatch('getMe')
  } catch (error) {
    console.error('Error validating user account:', error)
  }
}

function hasHydratedSession(targetStore) {
  return !_.isEmpty(targetStore?.state?.access?.account)
}

function revalidateSessionInBackground(targetStore) {
  targetStore.dispatch('getMe').catch(error =>
    console.error('Error revalidating user account:', error)
  )
}

export { fetchAccountInfo, hasHydratedSession }
